import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create personality result
export const createPersonalityResult = async (personality, answers) => {
  try {
    const response = await axios.post(`${API}/personality-results`, {
      personality,
      answers
    });
    return response.data;
  } catch (error) {
    console.error('Error creating personality result:', error);
    throw error;
  }
};

// Get all personality results
export const getPersonalityResults = async () => {
  try {
    const response = await axios.get(`${API}/personality-results`);
    return response.data;
  } catch (error) {
    console.error('Error fetching personality results:', error);
    throw error;
  }
};

// Share a personality result
export const sharePersonalityResult = async (resultId) => {
  try {
    const response = await axios.put(`${API}/personality-results/${resultId}/share`);
    return response.data;
  } catch (error) {
    console.error('Error sharing personality result:', error);
    throw error;
  }
};

// Get personality data
export const getPersonalities = async () => {
  try {
    const response = await axios.get(`${API}/personalities`);
    return response.data;
  } catch (error) {
    console.error('Error fetching personalities:', error);
    throw error;
  }
};